/**
 * Child-batch audit trail for a durable manual-ingestion parent.
 */

import type { JobBatchSummary } from "../../api/clinicalTrialsApiTypes";
import { JobStatusBadge } from "./JobStatusBadge";

interface JobBatchDetailsProps {
  batches: JobBatchSummary[];
}

/**
 * Render ordered child attempts and per-batch progress.
 *
 * @param props - Durable child-batch summaries
 * @returns Batch audit section, or null for legacy jobs
 */
export function JobBatchDetails({ batches }: JobBatchDetailsProps) {
  if (!batches.length) return null;
  return (
    <div className="mt-5 border-t border-gray-200 pt-4">
      <h3 className="mb-2 text-sm font-semibold">Batches ({batches.length})</h3>
      <div className="max-h-52 space-y-2 overflow-y-auto">
        {batches.map((batch) => (
          <div
            key={batch.batch_id}
            className="rounded-md border border-gray-200 p-3 text-xs"
          >
            <div className="mb-1 flex items-center justify-between">
              <span className="font-medium">Batch {batch.batch_index}</span>
              <JobStatusBadge status={batch.status} />
            </div>
            <p className="text-gray-600">
              {batch.processed_count} / {batch.total} terminal
              {batch.failed_count ? ` · ${batch.failed_count} failed` : ""}
            </p>
            {batch.error_message && (
              <p className="mt-1 text-red-700">{batch.error_message}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
